import { Sprite, Texture, Text } from 'pixi.js';
import Button from './Button';
import { Tween, Easing } from '@tweenjs/tween.js';

class ActionButton extends Button {
	constructor(obj) {
		super(obj);
		this.enabled = true;
		if (obj.bg) {
			this.bg = Sprite.from(Texture.from(obj.bg));
			this.addChild(this.bg);
			this.bg.anchor.set(0.5, 0.5);
		}
		if (obj.icon) {
			this.icon = Sprite.from(Texture.from(obj.icon));
			this.bg.addChild(this.icon);
			this.icon.anchor.set(0.5, 0.5);
		}
		if (obj.text) {
			this.text = new Text(
				window.lm[obj.text].value,
				window.lm[obj.text].config
			);
			this.text.anchor.set(0.5, 0.5);
			this.bg.addChild(this.text);
		}
		if (obj.bet) {
		} else {
			this.on(
				window.isMobile || window.isTablet
					? 'touchendoutside'
					: 'mouseupoutside',
				this.mouseUpHandler.bind(this)
			);
			this.on(
				window.isMobile || window.isTablet ? 'touchstart' : 'mousedown',
				this.mouseDownHandler.bind(this)
			);
			this.on(
				window.isMobile || window.isTablet ? 'touchend' : 'mouseup',
				this.mouseUpHandler.bind(this)
			);
		}
	}

	toggleEnabled(b) {
		this.enabled = b;
	}

	mouseUpHandler() {
		if (this.enabled) {
			if (this.tweenerUp) {
				this.tweenerUp.stop();
			}
			if (!this.tweenerUp || !this.tweenerUp.isPlaying()) {
				this.tweenerUp = new Tween(this.bg.scale)
					.to({ x: 1, y: 1 }, 50)
					.easing(Easing.Linear.None)
					.start();
			}
		}
	}
	mouseDownHandler() {
		if (this.enabled) {
			if (!this.tweenerUp || !this.tweenerUp.isPlaying()) {
				this.tweenerUp = new Tween(this.bg.scale)
					.to({ x: 0.95, y: 0.95 }, 50)
					.easing(Easing.Linear.None)
					.start();
			}
		}
	}

	getSize() {
		return {
			width: this.bg.width,
			height: this.bg.height
		};
	}
}

export default ActionButton;
